import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { IonicModule, ModalController } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { RoutePaths } from '../../../../core/constants/route-paths';

@Component({
  selector: 'app-policity-cookie-modal',
  standalone: true,
  imports: [CommonModule, IonicModule, TranslateModule],
  templateUrl: './policity-cookie-modal.component.html',
  styleUrl: './policity-cookie-modal.component.scss',
})
export class PolicityCookieModalComponent implements OnInit {
  modalTitle: string = '';
  modalInfo: string = '';

  constructor(private _modalController: ModalController,
    private readonly _router: Router
  ) {}

  ngOnInit() {}

  async openCookiesPage(): Promise<void> {
    this.dismiss();
    await this._router.navigate([`${RoutePaths.cookiesPage}`]);
  }

  dismiss() {
    this._modalController.dismiss();
  }
}
